import {TOKEN_REFRESH_STARTED, TOKEN_REFRESHED, USER_LOGIN, USER_LOGOUT} from 'state/actions';

const INITIAL_STATE = {
  token: null,
  isRefreshing: false,
  userInfo: null,
};

function persistAuthData(token, user) {
  if (token && localStorage.getItem('token') !== token) {
    localStorage.setItem('token', token);
  }

  if (user && localStorage.getItem('user') !== JSON.stringify(user)) {
    localStorage.setItem('user', JSON.stringify(user));
  }
}

function removeAuthData() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_LOGIN:
      // Store auth data in localStorage to be able to properly restore the redux store
      // on page refresh. We do it here since using store subscribers proved to be more
      // problematic (since the subscription callback is invoked on every action).
      persistAuthData(action.token, action.userInfo);
      return {token: action.token, userInfo: action.userInfo, isRefreshing: false};
    case USER_LOGOUT:
      removeAuthData();
      return {token: null, userInfo: null, isRefreshing: false};
    case TOKEN_REFRESH_STARTED:
      return {...state, isRefreshing: true};
    case TOKEN_REFRESHED:
      // Store auth data in localStorage to be able to properly restore the redux store
      // on page refresh
      persistAuthData(action.token);
      return {...state, token: action.token, isRefreshing: false};
    default:
      return state;
  }
}
